'use client'

import { BookingPageContext } from '@/components/pages/checkout/booking-page/BookingPageContext'
import React, { useContext } from 'react'
import { BookingRequestType, BookingResponseStatus } from '@/types/Booking'
import { BookingSuccess } from '@/components/pages/checkout/booking-page/booking-result/BookingSuccess'
import { BookingError } from '@/components/pages/checkout/booking-page/booking-result/BookingError'

export function BookingResult() {
  const { initialBookingData, saveBookingResponse, bookingSelection } =
    useContext(BookingPageContext)

  if (saveBookingResponse?.Status == BookingResponseStatus.Ok) {
    return (
      <BookingSuccess
        reservation={bookingSelection?.Reservation}
        request={initialBookingData?.Type === BookingRequestType.Request}
        message={saveBookingResponse?.StatusText}
      />
    )
  } else {
    return <BookingError />
  }
}
